import { queryOptions, skipToken } from "@tanstack/react-query";
import OAuth2Provider from "supertokens-web-js/recipe/oauth2provider";
import Session from "supertokens-web-js/recipe/session";

import { parseAccessTokenPayload } from "@/helpers/jwt";

export const SESSION_IDENTITY_QUERY_KEY = ["session-credential-identity"] as const;

export function sessionIdentityQueryOptions() {
  return queryOptions({
    queryKey: SESSION_IDENTITY_QUERY_KEY,
    queryFn: async () => {
      if (!(await Session.doesSessionExist())) {
        return null;
      }

      return parseAccessTokenPayload(await Session.getAccessToken()) ?? null;
    },
    staleTime: Infinity,
    retry: false,
  });
}

export function oauthLoginChallengeQueryOptions(loginChallenge: string | null) {
  return queryOptions({
    queryKey: ["oauth-login-challenge", loginChallenge],
    queryFn: loginChallenge
      ? async () => {
          const { info } = await OAuth2Provider.getLoginChallengeInfo({ loginChallenge });

          return info;
        }
      : skipToken,
    staleTime: Infinity,
    retry: false,
  });
}
